import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";

import TPLtableV3 from "../launchpadV3-table.mustache";
import TPLlaunchpadActivityV3 from "../widget/launchpadV3-activity.mustache";

  const
    BIRTHDAYS = [
      {text:"Anniversaire de Nina",firstname:"Nina",eventId:"event/12_12",startDate:"2012-12-12",allDay:true}
    ].map((e: any)=>new ApiServer.types.LaunchpadEvent(e)),
    EVENTS = [
      {text:"journée de l'andouillette",startDate:"2012-12-12",allDay:true},
      {text:"RDV docteur",startDate:"2012-12-12T15:30:00"},
      {text:"natation",color:"#FF8888",startDate:"2012-12-12T18:00:00",endDate:"2012-12-12T19:00:00"}
    ].map((e: any)=>new ApiServer.types.LaunchpadEvent(e));


  function buildBean(json: any, jsonOpeningMode: any): any {
    var result = new ApiServer.types.LaunchpadConditionBean({
      modifiedActivity:"false",
      modifiedActivityToday:"false",
      modifiedActivityThisWeek:"false",
      modifiedActivityThisMonth:"false",
      newLikesInActivity:"false",
      hasActivity:"false",
      nbMember:3,
      nbInvite:1,
      circleCount:1,
      upcomingBirthdays:[],
      upcomingEvents:[],
      eventDayCount:0,
      eventWeekCount:8,
      eventMonthCount:12,
      diduknowPremiumShowable:true,
      diduknowCreateCircleShowable:true,
      diduknowCoverShowable:true,
      diduknowProfileShowable:true,
      circleCreatedRecently:false


    });
    return Object.assign(result,json,jsonOpeningMode)
  }

  var
    LaunchpadOpeningEnum = ["FAMILY_CREATED","FAMILY_JOINED","ONCE_RETURNING","FIRST_OF_DAY","OTHERS"],
    requests: any[] = [
      {colName:"founderAlone",              inTable:true, nbMember:1,nbInvite:0},
      {colName:"founderWithPendingInvite",  inTable:true,nbMember:1,nbInvite:1},
      {colName:"birthdayToday"            , inTable:true,activitySeenToday:false,modifiedActivityThisMonth:true,eventDayCount:1,eventWeekCount:5,eventMonthCount:10,upcomingBirthdays:BIRTHDAYS,todayEvents:BIRTHDAYS},
      {colName:"eventToday"               , inTable:true,eventDayCount:3,eventWeekCount:5,eventMonthCount:10,todayEvents:EVENTS},
      {colName:"activitySeenRecently"     , inTable:false,activitySeenRecently:true},
      {colName:"modifiedActivity"         , inTable:true ,modifiedActivity:true,modifiedActivityToday:true,modifiedActivityThisWeek:true,modifiedActivityThisMonth:true,
        activityCover:'//stagingapi.familywall.com/media/243862_e%3AGeYyB22ksOCM7Xgp%3A2f%3BZ0ugi_105283?'},
      {colName:"newLike"                  , inTable:false,newLikesInActivity:true},
      {colName:"default"                  , inTable:true},
      {colName:"defaultWithAvatar"        , inTable:false, customAvatar:true},
      {colName:"allScreens"        , inTable:false, circleCount:-1,upcomingBirthdays:BIRTHDAYS,todayEvents:BIRTHDAYS}
      ];

   ApiServer.launchpadV3table = function(form: any): void {
    var usedRequests = requests.filter((r: any)=>r.inTable);
    var datas: any[]= [];
    datas[0] = [null].concat(usedRequests.filter((request: any) => {
      return {colName:request.colName};
    }));
   LaunchpadOpeningEnum.forEach(function(openingMode: string, rowIdx: number){
      var row = [{colName:openingMode}];
      datas.push(row);
      usedRequests.forEach(function(request: any, colIdx: number){
        ApiServer.launchpadget3(
          null,
          null,
          buildBean(request,{openingMode:openingMode}),
          function(bean: any){
            datas[rowIdx+1][colIdx+1] = bean;
          },function(error: any){
            console.log(error)
          }
        )
      });
    })
    ApiServer.aftergroup(function(){
      Html.setHtml(document.getElementById('container')!,TPLtableV3,datas)
    })
  }


  ApiServer.launchpadV3test = function(form: HTMLFormElement): void {
    var bean = buildBean({},{})

    form.querySelectorAll('input, select').forEach(function(input: any){
      if(input.nodeName==='SELECT'){
        var val: any = {};
        val[input.name] = (input as HTMLSelectElement).value;
        Object.assign(bean,val);
        console.log(input.name,val[input.name])
      }else if(input.className==='group'){
        if(input.checked){
          console.log(input.name,requests.find(function(el: any){return el.colName === input.name}))
          Object.assign(bean,requests.find(function(el: any){return el.colName === input.name}));
        }
      }else if(input.className==='direct'){
        bean[input.name] = input.checked;
        console.log(input.name,input.checked)
      }

    })
    ApiServer.launchpadget3(null,null,bean,function(beanres: any){
      const launchpadResult = document.getElementById('launchpadresult');
      if(launchpadResult) launchpadResult.innerHTML = '';
      console.log("success")
      console.log(beanres)
      if(beanres.activities){
        for(var i=0;i<beanres.activities.length;i++){
          Html.setHtmlAtEndDom(launchpadResult,TPLlaunchpadActivityV3,beanres.activities[i])
        }

      }
//      Html.setHtml(document.getElementById('launchpadresult'),TPLlaunchpad,bean)
    },function(error: any){
      console.log(error)
    })
    console.log(bean)
  }
